import Overlay from "ol/Overlay";
import { checkIconSvg, copyIconSvg } from "../../../../../../assets/icons";
import { focusOverlayInState, removeOverlayFromStateById } from "../overlayState";

type RoadCameraInfoOverlayData = {
    fields: {
        label: string;
        value: string;
    }[];
};

async function copyToClipboard(text: string) {
    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch {
        try {
            const textarea = document.createElement("textarea");
            textarea.value = text;
            textarea.style.position = "fixed";
            textarea.style.left = "-9999px";
            textarea.style.top = "-9999px";
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            const ok = document.execCommand("copy");
            document.body.removeChild(textarea);
            return ok;
        } catch {
            return false;
        }
    }
}

export function buildRoadCameraInfoOverlay(overlayId?: string | number, data?: RoadCameraInfoOverlayData) {
    const element = document.createElement("div");
    element.className = "ol-popup ol-popup--road-camera-info";
    element.onclick = (event) => {
        const target = event.target as HTMLElement | null;
        if (target?.closest("button")) return;
        focusOverlayInState(overlayId);
    };

    const overlay = new Overlay({
        element,
        positioning: "bottom-center",
        offset: [0, -18],
        stopEvent: true,
        insertFirst: false,
    });

    const closeButton = document.createElement("button");
    closeButton.type = "button";
    closeButton.className = "ol-popup__close";
    closeButton.innerHTML = "&times;";
    closeButton.title = "Close";
    closeButton.onclick = () => {
        overlay.setPosition(undefined);
        removeOverlayFromStateById(overlayId);
    };

    const content = document.createElement("div");
    content.className = "ol-popup__content";

    const rows = document.createElement("div");
    rows.className = "ol-popup__rows";

    data?.fields?.forEach((field) => {
        if (!field?.label || !field?.value) return;

        const row = document.createElement("div");
        row.className = "ol-popup__row ol-popup__row--long";

        const textContainer = document.createElement("div");
        textContainer.className = "ol-popup__row-text";

        const label = document.createElement("span");
        label.className = "ol-popup__label";
        label.textContent = field.label;

        const value = document.createElement("span");
        value.className = "ol-popup__value";
        value.textContent = field.value;

        const copyBtn = document.createElement("button");
        copyBtn.type = "button";
        copyBtn.className = "ol-popup__row-copy-btn";
        copyBtn.innerHTML = copyIconSvg;
        copyBtn.title = "Copy";
        copyBtn.onclick = async () => {
            const ok = await copyToClipboard(field.value);
            if (ok) {
                copyBtn.innerHTML = checkIconSvg;
                copyBtn.classList.add("copied");
                setTimeout(() => {
                    copyBtn.innerHTML = copyIconSvg;
                    copyBtn.classList.remove("copied");
                }, 1200);
            }
        };

        textContainer.appendChild(label);
        textContainer.appendChild(value);
        row.appendChild(textContainer);
        row.appendChild(copyBtn);
        rows.appendChild(row);
    });

    content.appendChild(rows);
    element.appendChild(closeButton);
    element.appendChild(content);

    return overlay;
}
